// extracted by mini-css-extract-plugin
export default {"container":"mjl1pdDh","title":"bS8Dkt5C","description":"rgHzv1X8"};